import { Injectable } from '@angular/core';

import { Page } from '@frontend/vanilla/core';

import { PromoDesignSystemConfiguration } from '../configs/design-system-config';
import { CommonConstants } from '../constants/common-constants';
import { DSComponents } from '../model/ds-components';

@Injectable({
    providedIn: 'root',
})
export class DesignSystemHelperService {
    constructor(
        private designSystemConfig: PromoDesignSystemConfiguration,
        private page: Page,
    ) {}

    getDsComponentsList(key: string = CommonConstants.Default) {
        return {
            dsPill: this.designSystemConfig?.dsPill ? this.getDsConfig(this.designSystemConfig?.dsPill[key]) : null,
            dsNotificationBubble: this.designSystemConfig?.dsNotificationBubble
                ? this.getDsConfig(this.designSystemConfig?.dsNotificationBubble[key])
                : null,
            dsDivider: this.designSystemConfig?.dsDivider ? this.designSystemConfig?.dsDivider[key] : null,
            dsCardStatic: this.designSystemConfig?.dsCardStatic ? this.designSystemConfig?.dsCardStatic[key] : null,
            dsArrow: this.designSystemConfig?.dsArrow ? this.designSystemConfig?.dsArrow[key] : null,
            dsButton: this.designSystemConfig?.dsButton ? this.designSystemConfig?.dsButton[key] : null,
            dsBadges: this.designSystemConfig?.dsBadges ? this.getDsConfig(this.designSystemConfig?.dsBadges[key]) : null,
            dsTabsGroup: this.designSystemConfig?.dsTabsGroup ? this.getDsConfig(this.designSystemConfig?.dsTabsGroup[key]) : null,
            dsTooltip: this.designSystemConfig?.dsTooltip ? this.getDsConfig(this.designSystemConfig?.dsTooltip[key]) : null,
            dsAccordion: this.designSystemConfig?.dsAccordion ? this.getDsConfig(this.designSystemConfig?.dsAccordion[key]) : null,
        } as DSComponents;
    }

    getDsConfig(dsObj: any, isFlipRequired: boolean = false) {
        if (dsObj?.lightModeThemes != null && this.page?.theme) {
            const lightModeThemes = dsObj.lightModeThemes.includes(this.page.theme?.toLowerCase());
            if (isFlipRequired && lightModeThemes) dsObj.inverse = !dsObj.inverse;
            else if (!dsObj?.inverse && lightModeThemes) dsObj.inverse = true;
        }
        return dsObj;
    }
}
